import { render } from "./App.vue?vue&type=template&id=45b50a19&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=45b50a19&lang=scss"
import "./App.vue?vue&type=style&index=1&id=45b50a19&lang=scss"

import exportComponent from "D:\\PROJECT\\Mbf5_HCC\\XaTanHungHph\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__